document.addEventListener("DOMContentLoaded", function () {
  const monogramPopup = document.querySelector("#monogram_popup");
  const monogramPopupOverlay = monogramPopup.querySelector(".monogram_popup--overlay");
  const monogramPopupWrapper = monogramPopup.querySelector(".monogram_popup--wrapper");
  const mngmClosePopup = document.querySelector("#mngm_closePopup");
  const stepBars = document.querySelectorAll("#mngm_step_count .step_bar");
  const stepCountElement = document.querySelector("[data-monogram-step-count]");
  const radioInputs = document.querySelectorAll("[data-radio-input]");
  const steps = document.querySelectorAll(".mngm_step_item");
  const addToCartBtn = document.querySelector("#addToCart");
  const nextButton = document.querySelector("#next_button");
  const nextButtonTxt = nextButton?.dataset.nextbtnText || "Next";
  const atcBtnTxt = nextButton?.dataset.atcText || "Add to Cart";  
  const backButton = document.querySelector("#back_button");
  const isTemplateMoreUpsells = document.querySelector(".monogram-more-upsells")
  const isTemplateMoreUpsellsSec = document.querySelector(".monogram-more-upsells-v1") 
  const isTemplatesocialProof = document.querySelector(".monogram-socialproof-v2") 
 
  let currentStep = 0;

  function initSteps() {
    steps.forEach((step, index) => {
      step.style.transition = "transform 0.4s ease, opacity 0.3s ease";

      if (index === 0) {
        activateStep(step);
      } else {
        deactivateStep(step);
      }
    });

    updateButtonStates();
  }

  function showStep(index) {
    if (index < 0 || index >= steps.length) return;
    
    deactivateStep(steps[currentStep]);
    activateStep(steps[index]);    
    if(stepCountElement) stepCountElement.innerText = index + 1;
    monogramPopup.setAttribute("data-monogram-step", index + 1);

    stepBars?.forEach((bar, barIndex) => {
      if (barIndex < index) {
        bar.classList.add("active_step_bar");
      } else {
        bar.classList.remove("active_step_bar");
      }
    });
         
    currentStep = index;
    updateButtonStates();
    
    if (currentStep >= 0 && currentStep < steps.length) {
      if (currentStep === steps.length - 1) {
          replaceNextButtonWithAddToCart();
      } else {
          restoreNextButton();
      }
    }
  }

  function replaceNextButtonWithAddToCart() {
    if (!document.querySelector("#addToCart")) {
      const productPrice = monogramPopup.dataset.productPrice;
      nextButton.style.display = "none";
      const addToCartBtn = document.createElement("button");
      addToCartBtn.id = "addToCart";
      addToCartBtn.type = "button";
      addToCartBtn.disabled = true;
      addToCartBtn.className = "continue-btn button button--primary";
      addToCartBtn.tabIndex = 0;
      addToCartBtn.innerHTML = `${atcBtnTxt} &nbsp; <span class='tgprice'>${productPrice}</span>
                                <div class="loading__spinner hidden">
                                  <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                    <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                                  </svg>
                                </div>`;
      nextButton.parentNode.insertBefore(addToCartBtn, nextButton.nextSibling);

      const formattedPrice = Shopify.formatMoney(monogramPopup.dataset.monogramProductPrice, window.money_format);
      addToCartBtn.querySelector(".tgprice").innerHTML = formattedPrice;
      addToCartBtn.querySelector(".tgprice").style.display = "block";
      addToCartBtn.addEventListener("click", handleAddToCart);
    }
  }

  function restoreNextButton() {
    nextButton.style.display = "";
    const addToCartBtn = document.querySelector("#addToCart");
    if (addToCartBtn) {
      addToCartBtn.remove();
    }
  }  

  async function handleAddToCart() {
    if (validateCurrentStep()) {
      const productMaterial = document.querySelector(".material_inputs.active").dataset.name;
      const productNameInputs = Array.from(document.querySelectorAll(".step_option_naam_input.active #productName"));
      const productName = productNameInputs.map((input, index) => {
        if (productNameInputs.length === 1) {
          return input.value
        } else {
          return `#${index + 1}-Naam-[${input.value}]`;
        }
      }).join(", ");
      const productDesign = document.querySelector(".input_name_design.active").dataset.designName;
      const mainProductId = document.getElementById("monogram_popup").dataset.productVariantId;
      const atcForm = document.querySelector(`.main-product-form[data-type="add-to-cart-form"]`);
      const atcMngmbtn = document.querySelector(".mngm--footer #addToCart");
      
      const birthstoneDesigns = Array.from(document.querySelectorAll(".birthstone_input.active")).map(el => el.dataset.value);
      const birthstoneDesign = birthstoneDesigns.join(", ");
    
      const productData = {
        "Materiaal": productMaterial,
        "Naam": productName,
        "Stijl": productDesign,
        "Geboortesteen": birthstoneDesign
      };

      let shouldUpdate = false;

      Object.entries(productData).forEach(([key, value]) => {
        const existingInput = document.querySelector(`input[name="properties[${key}]"]`);
        if (!existingInput || existingInput.value !== value) {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        document.querySelectorAll(".product-form form input.product-variant-properties").forEach(input => input.remove());
        document.querySelectorAll(".product-form form input.product-variant-id").forEach(input => input.remove());
        const activeDesignElement = document.querySelector(".input_name_design.active");

        let lastIndex = 0;

        const sharedUniqueId = Math.floor(100000000000 + Math.random() * 900000000000).toString();

        const addCommonProperties = (index) => {
          const uniqueIdInput = document.createElement('input');
          uniqueIdInput.type = 'hidden';
          uniqueIdInput.name = `items[${index}][properties][_product_key]`;
          uniqueIdInput.value = sharedUniqueId;
          uniqueIdInput.className = 'product-variant-properties';
          document.querySelector(".product-form form").appendChild(uniqueIdInput);
        };

        if (document.querySelector(".upsell_input.active")) {
          const upsellProductInput = document.createElement('input');
          upsellProductInput.type = 'hidden';
          upsellProductInput.name = `items[${lastIndex}][id]`;
          upsellProductInput.value = document.querySelector(".upsell_input.active").dataset.upsellProductvariantId;
          upsellProductInput.className = 'product-variant-id';
          document.querySelector(".product-form form").appendChild(upsellProductInput);
          addCommonProperties(lastIndex);
          lastIndex++;
        }

        document.querySelectorAll(".protection_warrenty_input.active")?.forEach((el, index) => {
          const variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.name = `items[${lastIndex + index}][id]`;
          variantInput.value = el.dataset.productVariantId;
          variantInput.className = 'product-variant-id';
          document.querySelector(".product-form form").appendChild(variantInput);
          addCommonProperties(lastIndex + index);
        });
        lastIndex += document.querySelectorAll(".protection_warrenty_input.active").length;

        document.querySelectorAll(".birthstone_input.active").forEach((el, index) => {
          const variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.name = `items[${lastIndex + index}][id]`;
          variantInput.value = el.dataset.productVariantId;
          variantInput.className = 'product-variant-id';
          document.querySelector(".product-form form").appendChild(variantInput);
          addCommonProperties(lastIndex + index);
        });
        lastIndex += document.querySelectorAll(".birthstone_input.active").length;

        // Add main product ID
        const mainProductInput = document.createElement('input');
        mainProductInput.type = 'hidden';
        mainProductInput.name = `items[${lastIndex}][id]`;
        mainProductInput.value = mainProductId;
        mainProductInput.className = 'product-variant-id';
        document.querySelector(".product-form form").appendChild(mainProductInput);
        addCommonProperties(lastIndex);

        if (activeDesignElement) {
          const designName = activeDesignElement.dataset.designName;
          const activeDesignImg = activeDesignElement.querySelector("img")?.src;

          if (activeDesignImg && designName !== "Custom") {
            const activeDesignInputImg = document.createElement('input');
            activeDesignInputImg.type = 'hidden';
            activeDesignInputImg.name = `items[${lastIndex}][properties][_active_design_img]`;
            activeDesignInputImg.value = activeDesignImg;
            activeDesignInputImg.className = 'product-variant-properties';
            document.querySelector(".product-form form").appendChild(activeDesignInputImg);
          }
        }

        // Add Properties to main product  
        Object.entries(productData).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `items[${lastIndex}][properties][${key}]`;
          input.value = value;
          input.className = 'product-variant-properties';
          document.querySelector(".product-form form").appendChild(input);
        });
      }
      console.log("Properties Data:", productData);

      const formData = new FormData(atcForm);
      atcMngmbtn.querySelector(".loading__spinner").classList.remove("hidden");
      atcMngmbtn.style.opacity = "0.5";
      atcMngmbtn.style.pointerEvents = "none";

      if (document.querySelector(".monogram_popup").hasAttribute('data-edit-form-id')) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        document.querySelector(`.monogram_popup`).removeAttribute("data-edit-form-id")
      }

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        closePopup();
        currentStep = 0;
        showStep(currentStep);

        document.dispatchEvent(new CustomEvent('cart:refresh', { 
          detail: { open: true }
        }));
      } else {
        const error = await response.text();
        console.error('Error adding to cart:', error);
        alert('There was an error adding the product to your cart. Please try again.');
      }

      atcMngmbtn.querySelector(".loading__spinner").classList.add("hidden");
      atcMngmbtn.style.opacity = "1";
      atcMngmbtn.style.pointerEvents = "auto";

      // Open %OFF Discount Popup
      if (!isTemplateMoreUpsells && !isTemplateMoreUpsellsSec && !isTemplatesocialProof) {
        document.querySelector("#slideCart").classList.add("active");
        document.body.classList.add("body-no-scrollbar");
      } 
    }
  }

  function activateStep(step) {
    step.classList.add('active_step');
    step.style.transform = "translateX(0)";
    step.style.opacity = "1";
  }

  function deactivateStep(step) {
    step.classList.remove('active_step');
    step.style.transform = "translateX(-100%)";
    step.style.opacity = "0";
  }

  function validateCurrentStep() {
    const currentStepElement = steps[currentStep];
    const radioButtons = currentStepElement.querySelectorAll('[data-radio-input].active');

    if (currentStepElement.classList.contains('mngm_content--monogram-more-upsells')) return true;

    const textInputElements = Array.from(currentStepElement.querySelectorAll('.step_option_naam_input.active [data-text-input]'));
    const textInputs = textInputElements.length > 0 ? textInputElements.every((input) => input.value.trim() !== '') : false;
    
    return radioButtons.length > 0 || textInputs;
  }

  function updateButtonStates() {
    backButton.disabled = currentStep === 0;
    backButton.classList.toggle('mngm_d_none', currentStep === 0);
    nextButton.disabled = !validateCurrentStep();

    setTimeout(() => {
      const addToCartBtn = document.querySelector("#addToCart"); 
      if (addToCartBtn)  addToCartBtn.disabled = !validateCurrentStep();
    }, 200);
  }

  nextButton.addEventListener('click', () => {
    if (currentStep < steps.length - 1) {
      showStep(currentStep + 1);
    }
  });

  backButton.addEventListener('click', () => {
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  });

  document.querySelector("#skipOffers").addEventListener("click", function () {
    document.querySelector("#slideCart").classList.remove("active");
    document.body.classList.remove("body-no-scrollbar");

    currentStep = 0;
    showStep(currentStep);
  });

  let designExist = false;
  const designNames = document.querySelector('[data-designvariant-json]');
  const rawNamesText = designNames.textContent.trim();
  const cleanedText = rawNamesText.replace(/\n/g, '').replace(/\s+/g, ' ').trim();
  const namesOfArray = cleanedText.split(',').map(e => e.trim()).filter(item => item !== '');

  async function getNames(inputValue = '') {
    if (inputValue) {
      const normalizedInput = inputValue.trim().toLowerCase();
      return namesOfArray.some(name => name.toLowerCase() === normalizedInput);
    }
    return false;
  }

  async function designSuggestion(productNameInputs) {
    let inputValue = null;

    for (const input of productNameInputs) {
      const val = input.value.trim().toLowerCase();
      const match = namesOfArray.find(name => name.toLowerCase() === val);
      if (match) {
        inputValue = match;
        break;
      }
    }
    
    designExist = await getNames(inputValue);

    const nameContainer = document.querySelector(".input_name_design_wrapper");
    const versionOneTranslation = nameContainer.getAttribute("varsion_one_translation");
    const versionTwoTranslation = nameContainer.getAttribute("varsion_two_translation");
    const versionTranslations = [versionOneTranslation, versionTwoTranslation];

    nameContainer.parentElement.classList.toggle('design_exists', designExist);

    if (designExist) {
      nameContainer.innerHTML = "";
      const NoOfElem = 2;

      for (let index = 0; index < NoOfElem; index++) {
          const div = document.createElement('div');
          div.className = 'image-item input_name_design existing_design_inputs';
          div.dataset.designName = `${inputValue}_v${index + 1}`;
          div.dataset.radioInput = true;
          const versionLabel = versionTranslations[index] || `Version #${index + 1}`;
          
          div.innerHTML = `
              <div class="version_design_bgd">
                  <span>${versionLabel}</span>
              </div>
              <div class="existing_design_image">
                  <img width="100%" height="100%" src="/cdn/shop/files/design_${inputValue}_v${index + 1}.png?&width=800" alt="${inputValue}_v${index + 1}" onerror="this.closest('.image-item').style.display = 'none'">
              </div>
          `;
          
          nameContainer.appendChild(div);
      }
      nameContainer.appendChild(customDesingElem);      
    } else {
      document.querySelector(".input_name_design_wrapper").innerHTML = preElemt;
    }
  }
  
  const preElemt = document.querySelector(".input_name_design_wrapper").innerHTML;
  const customDesingElem = document.querySelector(`[data-custom-design]`).cloneNode(true);
  
  document.querySelectorAll("#productName")?.forEach((input) => {
    input.addEventListener("input", async function() {
      nextButton.disabled = !validateCurrentStep();
      if (validateCurrentStep()) {
        const productNameInputs = Array.from(document.querySelectorAll(".step_option_naam_input.active #productName"));
        designSuggestion(productNameInputs);
      }
    });
  });

  document.querySelector("#nameCount")?.addEventListener("change", async function() {
    const inputValue = this.value.toLowerCase().trim();
    document.querySelectorAll(".step_option_naam_input")?.forEach((input, index) => {
      if (index < inputValue) {
        input.classList.remove("mngm_d_none");
        input.classList.add("active");
      } else {
        input.classList.add("mngm_d_none");        
        input.classList.remove("active");
      }
    });
    nextButton.disabled = !validateCurrentStep();
  });

  initSteps();

  document.querySelectorAll(".product-form .main-product-form .product-form__submit")?.forEach((button) => {
    button.addEventListener("click", function (e) {    
      e.preventDefault();
      e.stopPropagation();
      monogramPopup.classList.add("active");
      monogramPopupOverlay.classList.add("active");
      monogramPopupWrapper.classList.add("active");
      document.body.classList.add("body-no-scrollbar");
      initSteps();
    });
  });

  const closePopup = () => {
    monogramPopup.classList.remove("active");
    monogramPopupOverlay.classList.remove("active");
    monogramPopupWrapper.classList.remove("active");
    document.body.classList.remove("body-no-scrollbar");
    currentStep = 0;
  };

  monogramPopupOverlay?.addEventListener("click", () => {
    closePopup();
    currentStep = 0;
    showStep(currentStep);
  });

  mngmClosePopup?.addEventListener("click", () => {
    closePopup();
    currentStep = 0;
    showStep(currentStep);
  });

  function clearActiveRadios(container) {
    container?.querySelectorAll("[data-radio-input]").forEach(r => r.classList.remove("active"));
  }

  function birthstoneVariantImgUrlHandler() {
    const materialName = document.querySelector(".material_inputs.active")?.dataset?.matrialName;
    const activeBirthstones = document.querySelectorAll(".birthstone_input.active");    
    const monthNames = Array.from(activeBirthstones).map(el => el.dataset.monthName).filter(name => name && name.toLowerCase() !== "none");
    
    let birthstoneVariantImgUrl;
    
    if (monthNames.length > 0 && activeBirthstones.length > 0) {
      const allActiveBirthstone = monthNames.join('_');
      birthstoneVariantImgUrl = `/cdn/shop/files/necklace_${materialName}_${allActiveBirthstone}.png?&width=510`;
    } else {
      birthstoneVariantImgUrl = `/cdn/shop/files/necklace_${materialName}.png?&width=510`;
    }
    
    return birthstoneVariantImgUrl;
  }

  function updateBirthstoneImage(container, imageSrc) {
    const url = birthstoneVariantImgUrlHandler();
    container?.querySelector(".birthstone_main_product_image")?.setAttribute("src", url);
  }

  function updateColorImage(container, imageSrc) {
    container?.querySelector(".mngm_color_main_img")?.setAttribute("src", imageSrc);
    setTimeout(() => {
      const url = birthstoneVariantImgUrlHandler();
      container.closest(".mngm_step_content_container").querySelector(".birthstone_main_product_image")?.setAttribute("src", url);
    }, 100);
  }

  function calculateTotalPrice() {
    const basePrice = parseFloat(monogramPopup.dataset.mainProductPrice || 0);
    
    const birthstoneTotal = Array.from(document.querySelectorAll(".birthstone_input.active"))
      .reduce((sum, el) => sum + parseFloat(el.dataset.productPrice || 0), 0);
    
    const upsellTotal = Array.from(document.querySelectorAll(".upsell_input.active, .protection_warrenty_input.active"))
      .reduce((sum, el) => sum + parseFloat(el.dataset.productPrice || 0), 0);
    
    return basePrice + birthstoneTotal + upsellTotal;
  }

  function updatePriceDisplays(totalPrice) {
    const formattedPrice = Shopify.formatMoney(totalPrice, window.money_format);
    
    if (totalPrice > 0 && nextButton) {
      nextButton.innerHTML = `${nextButtonTxt} &nbsp; <span class='tgprice'>${formattedPrice}</span>`;
    }
    
    const addToCartBtn = document.querySelector("#addToCart"); 
    if (addToCartBtn) addToCartBtn.querySelector(".tgprice").textContent = formattedPrice;
    
    monogramPopup.dataset.monogramProductPrice = totalPrice;
  }

  
  function handleBirthstoneSelection(radio, popupInner) {
    if (isTemplateMoreUpsells || isTemplateMoreUpsellsSec  || isTemplatesocialProof) {
      const maxSelections = 2;
      const birthstoneRadios = popupInner.querySelectorAll(".birthstone_input");
      const selectedRadios = popupInner.querySelectorAll(".birthstone_input.active");
      
      radio.classList.toggle("active");
      
      if (radio.dataset.value === "Geen Geboortesteen") {
        birthstoneRadios.forEach(r => {
          if (r !== radio) r.classList.remove("active");
        });

        updateBirthstoneImage(popupInner, radio.dataset.image);
        return;
      }
      
      const geenGeboortesteen = popupInner.querySelector('.birthstone_input[data-value="Geen Geboortesteen"]');
      if (geenGeboortesteen) geenGeboortesteen.classList.remove("active");
      
      if (selectedRadios.length > maxSelections) {
        selectedRadios[selectedRadios.length - 1].classList.remove("active"); 
      }
    } 
    else {
      clearActiveRadios(popupInner);
      radio.classList.add("active");
    }
    
    updateBirthstoneImage(popupInner, radio.dataset.image);
  }
  
  function handleRadioSelection(radio) {
    const popupInner = radio.closest("[data-mngm-popup-inner]");
    const isBirthstone = radio.classList.contains("birthstone_input");
    const isUpsell = radio.classList.contains("upsell_input") || 
                    radio.classList.contains("protection_warrenty_input");

    if (isBirthstone && radio.dataset.image) {
      handleBirthstoneSelection(radio, popupInner);
    } 
    else if (isUpsell) {
      radio.classList.toggle("active");
    }
    else {
      clearActiveRadios(popupInner);
      updateColorImage(popupInner, radio.dataset.varColor);
      radio.classList.add("active");
    }

    updatePriceDisplays(calculateTotalPrice());
    updateButtonStates();
  }

  radioInputs?.forEach(radio => {
    radio.addEventListener("click", () => handleRadioSelection(radio));
  });

  document.addEventListener("click", function (e) {
    const clickedDesign = e.target.closest(".input_name_design");
    if (!clickedDesign) return;  

    const popupInner = clickedDesign.closest("[data-mngm-popup-inner]");
    if (popupInner) {
      popupInner.querySelectorAll("[data-radio-input]").forEach((radio) => {
        radio.classList.remove("active");
      });
      clickedDesign.classList.add("active");
    }
    updateButtonStates();
  });

  document.addEventListener("step_form_edit", function () {
    monogramPopup.classList.add("active");
    monogramPopupOverlay.classList.add("active");
    monogramPopupWrapper.classList.add("active");
    document.body.classList.add("body-no-scrollbar");
    
    const editFormId = sessionStorage.getItem("prefillCartItemId");
    monogramPopup.setAttribute('data-edit-form-id', editFormId)

    const storedData = JSON.parse(sessionStorage.getItem("cartItemData"));
    sessionStorage.removeItem('cartItemData');
    
    const prefillHandler = new MonogramFormPrefill();
    prefillHandler.initWithCartData(storedData[0]);
  });

  class MonogramFormPrefill {
    constructor() {
      this.previousData = null;
      this.formElements = {
        material: '.material_inputs',
        birthstone: '.birthstone_input',
        name: '#productName',
        style: '.existing_design_inputs',
        protection: '.protection_warrenty_input'
      };
    }

    extractPreviousData(cartItemData) {
      const data = {};
      
      if (cartItemData.materiaal) {
        data.material = cartItemData.materiaal;
      }
      if (cartItemData.naam) {
        data.name = cartItemData.naam;
      }
      if (cartItemData.stijl) {
        data.style = cartItemData.stijl;
      }
      if (cartItemData.geboortesteen) {
        data.birthstones = cartItemData.geboortesteen.split(', ');
      }
      
      return data;
    }

    prefillMaterial(materialValue) {
      const materialInputs = document.querySelectorAll(this.formElements.material);
      
      materialInputs.forEach(input => {
        const dataName = input.getAttribute('data-name');

        if (dataName === materialValue) {
          input.classList.add('active');

          setTimeout(() => {
            input.click();
          }, 1000);
          
          const varColor = input.getAttribute('data-var-color');
          if (varColor) {
            const mainImg = document.querySelector('.mngm_color_main_img');
            if (mainImg) {
              mainImg.src = varColor;
            }
          }
        } 
      });
    }

    prefillBirthstones(birthstoneValues) {
      const birthstoneInputs = document.querySelectorAll(this.formElements.birthstone);
      
      birthstoneInputs.forEach(input => {
        const dataName = input.getAttribute('data-name');
        const isSelected = birthstoneValues.some(birthstone => 
          dataName === birthstone || dataName.includes(birthstone)
        );
        
        if (isSelected) {
          input.classList.add('active');
          
          if (birthstoneValues[0] && dataName.includes(birthstoneValues[0])) {
            const imageUrl = input.getAttribute('data-image');
            if (imageUrl) {
              const mainImg = document.querySelector('.birthstone_main_product_image');
              if (mainImg) {
                mainImg.src = imageUrl;
              }
            }
          }
        } 
      });
    }

    prefillName(nameValue) {
      // Handle different name formats from cart data
      let namesToPrefill = [nameValue];

      // Parse complex name formats like "#1-Naam-[name], #2-Naam-[name 2], #3-Naam-[name 3]"
      if (nameValue.includes('#') && nameValue.includes('Naam')) {
        namesToPrefill = this.parseComplexNames(nameValue);
      }

      // Get the name count select element
      const nameCountSelect = document.querySelector('.name-count-input');
      const nameInputsContainer = document.querySelector('.step_option_naam_inputs_container');

      if (nameCountSelect && nameInputsContainer) {
        // Set the name count based on number of names
        const nameCount = namesToPrefill.length;
        nameCountSelect.value = nameCount.toString();

        // Trigger change event to update the UI
        const changeEvent = new Event('change', { bubbles: true });
        nameCountSelect.dispatchEvent(changeEvent);

        // Wait for UI to update, then fill the names
        setTimeout(() => {
          const activeNameInputs = document.querySelectorAll('.step_option_naam_input.active .name-input');

          namesToPrefill.forEach((name, index) => {
            if (activeNameInputs[index]) {
              activeNameInputs[index].value = name;
              const inputEvent = new Event('input', { bubbles: true });
              activeNameInputs[index].dispatchEvent(inputEvent);
              console.log(`Set name "${name}" for input ${index}`);
            } else {
              console.warn(`Name input ${index} not found`);
            }
          });

          console.log(`Set ${nameCount} names`);
        }, 100);
      } else {
        console.warn('Name count select or inputs container not found');
      }
    }

    parseComplexNames(complexNameString) {
      const names = [];
      const namePattern = /#\d+-Naam-\[([^\]]+)\]/g;
      let match;

      while ((match = namePattern.exec(complexNameString)) !== null) {
        names.push(match[1]);
      }

      return names.length > 0 ? names : [complexNameString];
    }

    prefillStyle(styleValue) {      
      setTimeout(() => {        
        document.querySelector(`.image-item.input_name_design[data-design-name="${styleValue}"]`).classList.add('active'); 
      }, 1500);
    }

    prefillForm(previousData) {      
      this.previousData = previousData;
      
      setTimeout(() => {
        if (previousData.material) {
          this.prefillMaterial(previousData.material);
        }
        
        if (previousData.birthstones) {
          this.prefillBirthstones(previousData.birthstones);
        }
        
        if (previousData.name) {
          this.prefillName(previousData.name);
        }
        
        if (previousData.style) {          
          this.prefillStyle(previousData.style);
        }
        
        console.log('Form pre-filled with data:', previousData);
      }, 100);
    }

    initWithCartData(cartItemProperties) {
      const extractedData = this.extractPreviousData(cartItemProperties);
      this.prefillForm(extractedData);
    }
  }

  // var swiper = new Swiper(".mngm_name_slider", {
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });

  // ==================================================
  // ================ LEESMEER MONOGRAM POPUP =================
  // ================================================

  const leesmeerButton = document.querySelector('.mngm_leesmeer');
  const leesmeerPopup = document.getElementById('servicePopup');

  leesmeerButton.addEventListener('click', function () {
    leesmeerOpenPopup();
  });

  function leesmeerOpenPopup() {
    leesmeerPopup.classList.add('active');
  }

  function leesmeerClosePopup() {
    leesmeerPopup.classList.remove('active');
  }

  leesmeerPopup.addEventListener('click', function (e) {
    if (e.target === leesmeerPopup) {
      leesmeerClosePopup();
    }
  });

  document.querySelectorAll('.mngm_popup_button, .mngm_popup_close').forEach(el => {
    el.addEventListener('click', function () {
      leesmeerClosePopup();
    });
  });

});